(function () {
  const ENHANCED_MARK = 'data-theme-accordion-enhanced';

  function unwrapInvalidParent(element) {
    const parent = element.parentElement;
    if (!parent || parent.tagName !== 'P') return;

    const grandParent = element.parentNode;
    if (!grandParent) return;

    while (parent.firstChild) {
      grandParent.insertBefore(parent.firstChild, parent);
    }
    parent.remove();
  }

  function createToggle() {
    const wrapper = document.createElement('div');
    wrapper.className = 'summary-accordion__plus-minus-wrapper theme-accordion__toggle flex justify-center align-center flex-shrink-0';
    wrapper.setAttribute('aria-hidden', 'true');

    const inner = document.createElement('span');
    inner.className = 'summary-accordion__plus-minus por flex justify-center align-center';

    for (let i = 0; i < 2; i++) {
      const line = document.createElement('span');
      line.className = 'summary-accordion__icon-line';
      inner.appendChild(line);
    }

    wrapper.appendChild(inner);
    return wrapper;
  }

  function enhanceDetails(details) {
    if (details.closest('details-accordion') || details.getAttribute(ENHANCED_MARK) === 'true') {
      return;
    }

    unwrapInvalidParent(details);

    const summary = details.querySelector('summary');
    if (!summary) return;

    let body = details.querySelector('.content-accordion__body');
    if (!body) {
      body = summary.nextElementSibling;
    }
    if (!body || body.tagName === 'SUMMARY') return;

    const titleText = summary.textContent.trim().replace(/^\+\s*/, '');
    if (!titleText) return;

    details.setAttribute(ENHANCED_MARK, 'true');

    summary.className = 'summary-accordion theme-accordion__summary flex align-center por';
    summary.replaceChildren();
    summary.appendChild(createToggle());

    const titleWrap = document.createElement('div');
    titleWrap.className = 'summary__title flex align-center flex-grow-1';

    const heading = document.createElement('h3');
    heading.className = 'h6 accordion__title theme-accordion__title font-heading-bold margin0';
    heading.textContent = titleText;

    titleWrap.appendChild(heading);
    summary.appendChild(titleWrap);

    body.className = 'accordion__content accordion__content--no-icon theme-accordion__content';

    const answer = document.createElement('div');
    answer.className = 'theme-accordion__answer';

    const answerBody = document.createElement('div');
    answerBody.className = 'theme-accordion__answer-body rte';

    while (body.firstChild) {
      answerBody.appendChild(body.firstChild);
    }

    answer.appendChild(answerBody);
    body.appendChild(answer);

    const parent = details.parentNode;
    const nextSibling = details.nextSibling;
    const accordion = document.createElement('details-accordion');
    accordion.className = 'accordion db theme-accordion__item';

    accordion.appendChild(details);
    parent.insertBefore(accordion, nextSibling);
  }

  function enhanceContainer(container) {
    if (container.tagName === 'DETAILS-ACCORDION') return;

    const detailsElements = [...container.querySelectorAll(':scope > details, :scope details')].filter(
      (details) => !details.closest('details-accordion') && details.getAttribute(ENHANCED_MARK) !== 'true'
    );

    if (!detailsElements.length) return;

    detailsElements.forEach(enhanceDetails);
  }

  function scan(root = document) {
    root.querySelectorAll('.rte .content-accordion').forEach((element) => {
      if (element.tagName === 'DETAILS-ACCORDION') return;

      if (element.tagName === 'DETAILS') {
        enhanceDetails(element);
        return;
      }

      enhanceContainer(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', () => scan());
})();
